// extracted by mini-css-extract-plugin
export var container = "styles-module--container--85d1e";
export var header__actions = "styles-module--header__actions--97a90";
export var header__actions_menu = "styles-module--header__actions_menu--78979";
export var header__actions_pagination = "styles-module--header__actions_pagination--25b66";
export var header__back = "styles-module--header__back--31927";
export var header__back_button = "styles-module--header__back_button--2e04c";
export var header__row = "styles-module--header__row--7bc3d";
export var header__title = "styles-module--header__title--30ad1";
export var header__title_and_subtitle_wrapper = "styles-module--header__title_and_subtitle_wrapper--fb670";
export var header__title_metadata = "styles-module--header__title_metadata--3e86a";
export var header__title_wrapper = "styles-module--header__title_wrapper--440bd";
export var layout = "styles-module--layout--45873";
export var section = "styles-module--section--46d44";
export var section__footer = "styles-module--section__footer--3e268";
export var section__header = "styles-module--section__header--d710b";
export var section__item = "styles-module--section__item--9dda0";
export var section__large = "styles-module--section__large--ea05c";
export var section__small = "styles-module--section__small--d2068";